import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import {
  PaintColorMaterial,
  PaintColorMaterialDark,
} from '../../utils/materials';

export function Nellie_2over2dresser(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Nellie 2-Over-2-Dresser.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-nellie_2_over_2_dresser-paint_color',
    aoIntensity,
  );
  // useSetMaterialFinish(
  //   PaintColorMaterialDark,
  //   currentMaterialFinish.paintColorFinish,
  //   defaultFinish.paintColorFinish,
  //   'ao-nellie_2_over_2_dresser-paint_color',
  //   aoIntensity,
  // );
  useEffect(() => {
    if (isAR) {
      handleExportGLTF({
        scene,
        fileName: 'Maine Cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <Shadow model={'Nellie 2-Over-2-Dresser'} />
    </group>
  );
}
